const AuthActionType = {
  AUTH_LOGIN_START: 'auth_login_start',
  AUTH_LOGIN_SUCCESS: 'auth_login_success',
  AUTH_LOGIN_FAILURE: 'auth_login_failure',
  AUTH_LOGIN_CHANGED: 'auth_login_changed',
  AUTH_LOGIN_RESET: 'auth_login_reset',
  AUTH_LOGOUT: 'auth_logout',
  AUTH_REHYDRATE_TOKEN: 'auth_rehydrate_token',
  AUTH_PASSWORD_CHANGED: 'auth_password_changed',
  AUTH_TOKENS_REFRESHED: 'auth_tokens_refreshed',
} as const;

export default AuthActionType;
